import React, { useEffect, useState } from 'react';
import './ConfettiAnimation.css';

// Celebratory colors - pastels plus gold accents
const CONFETTI_COLORS = [
  '#E6B3C2', // dusty rose
  '#F2C6A0', // peach
  '#D4C4E0', // lavender
  '#C9D3B8', // sage
  '#FFD700', // gold
  '#FFC0CB', // pink
  '#87CEEB', // sky blue
  '#F4EDE4', // cream
];

// Confetti shapes
const SHAPES = ['rectangle', 'square', 'ribbon'];

export default function ConfettiAnimation({ isActive, onComplete }) {
  const [particles, setParticles] = useState([]);

  useEffect(() => {
    if (!isActive) {
      setParticles([]);
      return;
    }

    // Generate confetti particles falling from top
    const newParticles = [];
    const numParticles = 50;

    for (let i = 0; i < numParticles; i++) {
      const shape = SHAPES[Math.floor(Math.random() * SHAPES.length)];
      const startX = Math.random() * 100; // Random horizontal position
      const drift = (Math.random() - 0.5) * 30; // Horizontal drift while falling

      newParticles.push({
        id: i,
        color: CONFETTI_COLORS[Math.floor(Math.random() * CONFETTI_COLORS.length)],
        shape,
        startX,
        endX: startX + drift,
        delay: Math.random() * 400,
        duration: 2000 + Math.random() * 1500,
        size: shape === 'ribbon' ? 3 + Math.random() * 2 : 6 + Math.random() * 6,
        height: shape === 'ribbon' ? 20 + Math.random() * 15 : undefined,
        rotation: Math.random() * 360,
        rotationSpeed: (Math.random() - 0.5) * 720, // How much to rotate during fall
        wobble: 5 + Math.random() * 10, // Horizontal wobble amplitude
        wobbleSpeed: 2 + Math.random() * 3, // Wobble frequency
      });
    }

    setParticles(newParticles);

    // Clear after animation completes
    const timeout = setTimeout(() => {
      setParticles([]);
      onComplete?.();
    }, 4000);

    return () => clearTimeout(timeout);
  }, [isActive, onComplete]);

  if (particles.length === 0) return null;

  return (
    <div className="confetti-animation-container">
      {particles.map((particle) => (
        <span
          key={particle.id}
          className={`confetti-particle confetti-${particle.shape}`}
          style={{
            '--start-x': `${particle.startX}vw`,
            '--end-x': `${particle.endX}vw`,
            '--delay': `${particle.delay}ms`,
            '--duration': `${particle.duration}ms`,
            '--size': `${particle.size}px`,
            '--height': particle.height ? `${particle.height}px` : `${particle.size}px`,
            '--color': particle.color,
            '--rotation': `${particle.rotation}deg`,
            '--rotation-end': `${particle.rotation + particle.rotationSpeed}deg`,
            '--wobble': `${particle.wobble}px`,
            '--wobble-speed': particle.wobbleSpeed,
          }}
        />
      ))}
    </div>
  );
}
